
import axios from "axios";
import { API_BASE } from "../config";

export const PostAction = (method,data,url)=> {
    axios.defaults.baseURL = API_BASE;
  return new Promise((resolve) =>{
        axios({
            method,
            url,
            data,
            headers:{
                "Content-type": "application/json",
            },
        })
        .then((res) =>{
            resolve(res.data)
        })
        .catch((err) =>{
            resolve(err?.response?.data || { status: 'failed', message: 'Request failed.' })
        })
  
    }
  )
}
